import type { ReactElement } from 'react';
import { MostPlayedBody, gamesMostPlayedSeo } from '@fias/public-site-ui';
import { siteOrigin, usePageHead } from '@/lib/document-head';
import { useGamesMostPlayed } from '../hooks/useGamesCatalog';
import { GamesLoadFailed, GamesLoading } from './GamesStatus';

/** The most played games, ranked: `/a/games/most-played` (the home's "See all"). */
export function GamesMostPlayedPage(): ReactElement {
  const mostPlayed = useGamesMostPlayed();
  const seo = mostPlayed.data ? gamesMostPlayedSeo(mostPlayed.data, siteOrigin() ?? '') : null;
  usePageHead(
    seo
      ? {
          title: seo.title,
          description: seo.description,
          canonicalPath: seo.canonicalPath,
          jsonLd: siteOrigin() ? seo.jsonLd : [],
        }
      : null,
  );

  if (mostPlayed.isError && !mostPlayed.data) {
    return <GamesLoadFailed what="These games" onRetry={() => void mostPlayed.refetch()} />;
  }
  if (!mostPlayed.data) return <GamesLoading />;
  return <MostPlayedBody data={mostPlayed.data} />;
}
